// import dashboardIcon from '../icons/dashboard.svg'
// import ecologyIcon from '../icons/ecology.svg'
import commercialIcon from '../icons/analytics/commercial.svg'
import metricsIcon from '../icons/analytics/metrics.svg'
import summaryIcon from '../icons/analytics/summary.svg'
import sunlightIcon from '../icons/common/external.svg'
import loadsIcon from '../icons/common/loads.svg'
import areasheduleIcon from '../icons/common/square_thin.svg'
import modelIcon from '../icons/map/3d.svg'

export default [
  {
    name: 'Commercial',
    icon: commercialIcon,
    key: 'commercial'
  },
  {
    name: 'Area Schedule',
    icon: areasheduleIcon,
    key: 'areaSchedule'
  },
  {
    name: 'Elemental Summary',
    icon: summaryIcon,
    key: 'elementalSummary'
  },
  {
    name: 'Metrics',
    icon: metricsIcon,
    key: 'metrics'
  },
  // {
  //   name: 'Dashboard',
  //   icon: dashboardIcon,
  //   key: 'dashboard'
  // },
  // {
  //   name: 'Ecology',
  //   icon: ecologyIcon,
  //   key: 'ecology'
  // },
  {
    name: 'Environment',
    icon: loadsIcon,
    key: 'environment'
  },
  // {
  //   name: "Infrastructure",
  //   icon: defaultIcon,
  //   key: 'infrastructure'
  // },
  // {
  //   name: 'Structure',
  //   icon: modelIcon,
  //   key: 'structure'
  // },
  {
    name: 'Architecture',
    icon: modelIcon,
    key: 'architecture'
  },
  {
    name: 'Sunlight',
    icon: sunlightIcon,
    key: 'sunlight'
  }
]

export const FROZEN_GROUPS = ['Cost of modules']

export const FROZEN_ELEMENTS = [
  'MEPH Services',
  'Mechanical',
  'Electrical',
  'Lifts',
  'Lifts for 2700x2100 shaft',
  'Lifts for 2100x900 shaft',
  'Total',
  'Sub-Total',
  'On-Costs',
  'Preliminaries',
  'Cost of modules'
]

export const ONLY_EDITABLE_ELEMENTS = [
  'Shell and Core',
  'Fitout',
  'BWIC',
  'Lift Cost',
  'Lift Stop Cost'
]

export const LIFTS_ELEMENTS = ['Lift Cost', 'Lift Stop Cost']

export const tableHeadUnitMixSummary = ['Name', 'Nr', 'Area m²', 'Mix']
export const tableHeadUnitMixSummaryDistrict = ['Name', 'Nr', 'Mix']
export const tableHeadTotalAreaScheduleDistrict = [
  'Description',
  'GIA, m²',
  'NIA, m²',
  'GEA, m²'
]
export const tableHeadCostSummary = currency => [
  'Description',
  'Total',
  `${currency}/sqft`,
  '%'
]
export const tableHeadCostSummaryDistrict = ['Description', 'Total', '%']
export const tableHeadAreaScheduleSummary = [
  'Description',
  'NIA(m²)',
  'NIA(ft²)',
  'GIA(m²)',
  'GIA(ft²)',
  'Net Gross'
]
export const tableHeadAreaSchedule = isMeter => [
  'Floor Level',
  'Units',
  `Resi(NIA) ${isMeter ? 'm²' : 'ft²'}`,
  `GIA ${isMeter ? 'm²' : 'ft²'}`,
  `GEA ${isMeter ? 'm²' : 'ft²'}`
]
export const tableHeadElementalSummary = currency => [
  'Description',
  'Quantity',
  'Unit',
  'Rate',
  'Total',
  `${currency}/sqft GIA`,
  `${currency}/unit`
]
export const tableHeadModuleMixSummary = ['Name', 'Nr', 'Mix']
export const tableHeadSC = ['Shell and Core', 'Metric']
export const tableHeadFacade = ['Facade', 'Metric']
export const tableHeadModular = ['Modular', 'Metric']
export const tableHeadFitout = ['Fitout', 'Metric']
export const tableHeadMEP = ['MEP', 'Metric']
export const tableHeadWidget = ['Name', 'Quantity', 'Unit']

export const currencySymbols = ['£', '$', '€']
